// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__IframeAppStarter__iframeMicroAppFloorPlan.jut__IframeAppStarter__iframeMicroAppFloorPlan{min-height:100%}", "",{"version":3,"sources":["webpack://./../../../src/microFrontendSide/IframeAppStarter/IframeAppStarter.module.scss","webpack://./../../platform/@jutro/micro-frontends/microFrontendSide/IframeAppStarter/IframeAppStarter.module.css"],"names":[],"mappings":"AAAA,+FACE,eCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframeMicroAppFloorPlan": "jut__IframeAppStarter__iframeMicroAppFloorPlan"
};
export default ___CSS_LOADER_EXPORT___;
